import { createContext, useContext } from 'react';
import type { Me, TokenGetter } from './api.ts';
import type { AuthClient } from './auth.ts';

export interface Session {
  me: Me;
  auth: AuthClient;
  getToken: TokenGetter;
  /** Neuer Stand der angemeldeten Person (z. B. nach dem Speichern im Profil). */
  updateMe: (me: Me) => void;
}

export const SessionContext = createContext<Session | null>(null);

export function useSession(): Session {
  const s = useContext(SessionContext);
  if (!s) throw new Error('useSession außerhalb der Anmeldung');
  return s;
}
